import * as Klaro from "klaro/dist/klaro-no-css";
import { config } from "@/composable/useInitializeKlaro/config.ts";

declare global {
    interface Window {
        klaro: unknown;
        klaroConfig: unknown
    }
}

export const useInitializeKlaro = () => {
    const setup = () => {
        Klaro.setup(config);
        window.klaro = Klaro;
        window.klaroConfig = config;
    };

    return { setup };
};
